"use client";
import CountdownTimer from "@/components/common/CountdownTimer";
import Heading from "@/components/common/Heading";
import { TitleSize } from "@/constants/content";
import s from "./Timer.module.scss";
import TimeUnit from "./TimeUnit";

export interface TimerProps {
  heading?: string;
  startDate?: string;
  startTime?: string;
  show?: boolean;
}

export default function Timer(props: TimerProps) {
  const { heading, startDate, startTime, show } = props;

  if (!show || !startDate) {
    return null;
  }

  return (
    <div className={s.wrapper}>
      <CountdownTimer
        date={startDate}
        time={startTime}
        header={
          heading && (
            <Heading
              type="plain"
              tag={TitleSize.H4}
              text={heading}
              className={s.heading}
            />
          )
        }
        renderTimeUnit={(timeValue, timeType) => (
          <TimeUnit value={timeValue} type={timeType} />
        )}
      />
    </div>
  );
}
